<template>
    <div class="loading-skeleton">
        <div class="loading-text">Loading...</div>
        <div class="skeleton-title"></div>
        <div class="skeleton-text"></div>
        <div class="skeleton-text short"></div>
    </div>
</template>

<script setup>
import {GRADIENTS, COLORS} from "@/styles/brand";
</script>

<style scoped>
.loading-skeleton {
    background: linear-gradient(145deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 40px;
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
    text-align: center;
    max-width: 450px;
    color: #FFFFFF;
    position: relative;
    z-index: 1;
    animation: fadeInScale 0.6s ease-out;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.loading-text {
    color: #FFFFFF;
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 16px;
}

.skeleton-title {
    height: 32px;
    background: linear-gradient(90deg, rgba(255,255,255,0.1) 25%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.1) 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 8px;
    width: 70%;
    margin: 0 auto;
}

.skeleton-text {
    height: 20px;
    background: linear-gradient(90deg, rgba(255,255,255,0.1) 25%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.1) 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
    width: 100%;
}

.skeleton-text.short {
    width: 60%;
    margin: 0 auto;
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

@keyframes fadeInScale {
    from {
        opacity: 0;
        transform: scale(0.9) translateY(20px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}
</style>